class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.modalId = this.getAttribute('id');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));

    // Update the close button event handler to explicitly prevent default and stop propagation
    const closeButton = this.querySelector('button[type="button"]');
    closeButton.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      this.close();
    });

    this.summaryToggle.setAttribute('role', 'button');

    // Set up external triggers
    this.setupExternalTriggers();
  }

  setupExternalTriggers() {
    // Find all elements with data-modal-trigger attribute matching this modal's ID
    const externalTriggers = document.querySelectorAll(`[data-modal-trigger="${this.modalId}"]`);

    externalTriggers.forEach((trigger) => {
      // Remove existing event listeners to prevent duplicates
      const newTrigger = trigger.cloneNode(true);
      trigger.parentNode.replaceChild(newTrigger, trigger);

      newTrigger.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.open(event);
      });
    });
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (this.justOpened) return;

    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.justOpened = true;

    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    this.detailsContainer.setAttribute('open', true);

    // Add a class to help with animations
    this.classList.add('is-open');

    requestAnimationFrame(() => {
      document.body.addEventListener('click', this.onBodyClickEvent);
      this.justOpened = false;
    });

    document.body.classList.add('overflow-hidden');

    // Give a small delay to allow embedded content to initialize
    setTimeout(() => {
      try {
        const modalContent = this.detailsContainer.querySelector('.page-modal-inner-content');
        const firstFocusableElement = this.detailsContainer.querySelector(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );

        trapFocus(
          modalContent || this.detailsContainer.querySelector('[tabindex="-1"]'),
          firstFocusableElement || this.detailsContainer.querySelector('input:not([type="hidden"])')
        );
      } catch (e) {
        console.warn('Focus trapping issue in modal:', e);
      }
    }, 100);
  }

  close(focusToggle = true) {
    try {
      removeTrapFocus(focusToggle ? this.summaryToggle : null);
    } catch (e) {
      console.warn('Issue removing focus trap:', e);
    }

    // Remove the open class before closing
    this.classList.remove('is-open');

    // Add a small delay to allow animations to complete
    setTimeout(() => {
      this.detailsContainer.removeAttribute('open');
    }, 300);

    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

// Subscribe to the variant change event to reinitialize modal triggers
document.addEventListener('DOMContentLoaded', () => {
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, () => {
      document.querySelectorAll('details-modal').forEach((modal) => {
        if (modal.isConnected) {
          modal.setupExternalTriggers();
        }
      });
    });
  }
});

customElements.define('details-modal', DetailsModal);
